module.exports = __webpack_public_path__ + "media/images/sec_5-5-99ccc031b160d18966505f3c4eeabe6a.png";